import React from "react";
import { FaPen, FaTrash, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const BannerTable = ({ banners, onDelete, onEdit, canWrite = true }) => {
  if (!Array.isArray(banners)) {
    return <div className="no-variants-message">Loading banners...</div>;
  }

  if (banners.length === 0) {
    return (
      <div className="no-variants-message">
        <p>No banners found</p>
      </div>
    );
  }

  return (
    <div className="luxury-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Title</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {banners.map((b) => (
            <tr key={b._id || b.id}>
              <td>
                {b.image ? (
                  <img
                    src={typeof b.image === 'object' ? b.image.url : b.image}
                    alt={b.title}
                    style={{ width: "80px", height: "40px", objectFit: "cover", borderRadius: "8px" }}
                  />
                ) : (
                  <div className="no-image-placeholder">🖼️</div>
                )}
              </td>
              <td style={{ fontWeight: "700", color: "#181c32" }}>{b.title}</td>
              <td>
                <span className={`status-pill ${b.isActive ? 'active' : 'inactive'}`}>
                  {b.isActive ? (
                    <><FaCheckCircle size={12} /> Yes</>
                  ) : (
                    <><FaTimesCircle size={12} /> No</>
                  )}
                </span>
              </td>
              <td>
                <div className="table-actions">
                  {canWrite && (
                    <>
                      <button className="action-btn edit" onClick={() => onEdit(b)} title="Edit">
                        <FaPen />
                      </button>
                      <button className="action-btn delete" onClick={() => onDelete(b._id || b.id)} title="Delete">
                        <FaTrash />
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BannerTable;
